import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h4 className="text-lg font-heading font-semibold text-background-50 mb-4">
                <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">掌中之物</Link>
              </h4>
              <p className="text-sm leading-relaxed text-background-50/60">
                专注于每一件值得被双手珍视的精品。从选材到工艺，从触感到故事，方寸之间，无限魅力。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">精品分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
                <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
                <li><Link to="/article/wenwan-panwan-rumen" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">精选文章</Link></li>
                <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
                <li><a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5 text-sm text-background-50/60">
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                  <span>北京市朝阳区建国路88号SOHO现代城A座15层</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line text-primary-400"></i>
                  <span>400-888-6666</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>service@zhangzhongzhiwu.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-wechat-line text-primary-400"></i>
                  <span>微信：zhangzhongzhiwu</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-50/40">
              &copy; {new Date().getFullYear()} 掌中之物 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500/20 text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500/20 text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500/20 text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}